import * as React from 'react';
import ArrowRightOutlined from './arrow-right-outlined';
import ArrowRightFilled from './arrow-right-filled';
import type { IconCombinedProps } from './types';
const ArrowRightCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ArrowRightFilled ref={ref} {...rest} />;
  }
  return <ArrowRightOutlined ref={ref} {...rest} />;
});
export default ArrowRightCombined;